<div class="manual-address">
	<form [formGroup]="form" class="manual-address__fields" [ngClass]="{'manual-address__full' : showFullAddress}">
		<div class="manual-address__fields--top" [ngClass]="{'triple-grid' : showFullAddress}">
			<tc-autocomplete-field *ngIf="showFullAddress" controlName="unitType" label="Unit type"
				placeholder="e.g. Unit" keyRestrictions="alpha-only" [scroll]="true" [selfFilter]="true"
				[setOptions]="unitTypes" [errorFn]="_handleUnitTypeError">
			</tc-autocomplete-field>
			<tc-input-field controlName="unitNo" keyRestrictions="alpha-numeric" placeholder="e.g. Unit"
				[label]="showFullAddress ? 'Unit #' : 'Unit number'" [required]="conditionalRequired && showFullAddress"
				[conditionalValidation]=true [errorFn]="_handleUnitNoError"></tc-input-field>
			<tc-input-field *ngIf="showFullAddress" controlName="unitNoSuffix" keyRestrictions="alpha-only"
				label="Unit # S" placeholder="e.g. A" [errorFn]="_handleUnitNoSuffixError" [maxLength]="1">
			</tc-input-field>
		</div>
		<tc-input-field controlName="streetNo" label="Street number" placeholder="e.g. 1" keyRestrictions="numeric-only"
			[errorFn]="_handleStreetNoError" [maxLength]="10"></tc-input-field>
		<tc-input-field *ngIf="showFullAddress" keyRestrictions="alpha-only" controlName="streetNoSuffix"
			label="Street # S" placeholder="e.g. A" [errorFn]="_handleUnitNoSuffixError" [maxLength]="1">
		</tc-input-field>
		<tc-input-field controlName="streetName" label="Street name" placeholder="e.g. Flinders"
			keyRestrictions="alpha-only" [errorFn]="_handleStreetNameError"></tc-input-field>
		<tc-autocomplete-field controlName="streetType" label="Street type" placeholder="e.g. Road"
			keyRestrictions="alpha-only" [scroll]="true" [selfFilter]="true" [setOptions]="streetTypes"
			[errorFn]="_handleStreetTypeError"></tc-autocomplete-field>
		<tc-autocomplete-field controlName="postcode" label="Post code" placeholder="e.g. Melbourne / 3000"
			keyRestrictions="numeric-only" displayOption="Suburb" (selection)="handlePostcodeSelection($event)"
			[errorFn]="_handlePostcodeError" [minLength]="4" [scroll]="true" [setOptions]="suburbs">
		</tc-autocomplete-field>
		<tc-input-field controlName="suburb" label="Suburb" placeholder=""></tc-input-field>
		<tc-input-field controlName="state" label="State" placeholder="e.g. VIC"></tc-input-field>
	</form>
	<div class="manual-address__toggle" (click)="toggleAddress();">
		<div class="toggle__text">{{ showFullAddress ? "Hide" : "Show" }} full address search</div>
		<div class="arrow" [ngClass]="{'flip' : showFullAddress}"></div>
		<div class="addspace" *ngIf="showFullAddress"></div>
	</div>
	<div class="manual-address__actions" *ngIf="isQualification">
		<dodo-button class="manual-address__actions--back" width="110px" text="Back" color="white" (clicked)="goBack()">
		</dodo-button>
		<dodo-button class="manual-address__actions--continue" width="250px" text="View Available Plans" color="primary"
			(clicked)="submitManualAddress()" [disabled]="!formValid"></dodo-button>
	</div>
</div>